import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Base from '../Base';
import Card from '../../components/elements/Card';
import Title from '../../components/common/Title';
import Back from '../../components/common/Back';
import Icon from '../../components/common/Icon';
import { apiRequest } from '../../utils';
import './MemberHome.css';

/* All blog / content-feed items — the "Show more" target on both the Bravos member home and the
   HT/PLG participant home (each shows only the latest few). Backend: GET /api/content-feed. */
const BlogList = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [items, setItems] = useState(null);

  useEffect(() => {
    let cancelled = false;
    apiRequest('GET', '/content-feed')
      .then((res) => { if (!cancelled) setItems(res.items || []); })
      .catch(() => { if (!cancelled) setItems([]); });
    return () => { cancelled = true; };
  }, []);

  return (
    <Base activeNav="home">
      <Card>
        <Back to="/member-home" />
        <Title my="1" className="mt-3">
          <Icon name="newspaper" theme="primary" className="me-2" />
          {t('latestContent')}
        </Title>

        {items === null ? (
          <span className="auth__spinner" />
        ) : items.length === 0 ? (
          <p className="text-muted mb-0">{t('noBlogs')}</p>
        ) : (
          items.map((it, i) => (
            <a
              key={i}
              className="bravos-feed"
              href={it.url || '#'}
              target="_blank"
              rel="noopener noreferrer"
            >
              {it.image && (
                <span
                  className="bravos-feed__thumb"
                  style={{ backgroundImage: `url("${it.image}")` }}
                />
              )}
              <span className="bravos-feed__body">
                <span className="bravos-feed__title">
                  {it.title}
                  {/* A company admin reads every brand's articles, and a company's own ones are
                      mixed in: each names whose it is, as on the home card. */}
                  {(it.source === 'brand' || it.source === 'company') && it.source_label && (
                    <span className="bravos-feed__source">{it.source_label}</span>
                  )}
                </span>
                {it.summary && <span className="bravos-feed__summary">{it.summary}</span>}
              </span>
              <Icon name="angle-right" className="bravos-event__chev" />
            </a>
          ))
        )}
      </Card>
    </Base>
  );
};

export default BlogList;
